module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-expand-height', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.showError),
      expression: "!!showError"
    }],
    staticClass: "form-error"
  }, [_c('span', {
    staticClass: "small form-error__error",
    domProps: {
      "innerHTML": _vm._s(_vm.lastError === true ? "Something went wrong" : _vm.lastError)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b98c41"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Error.vue
// module id = 251
// module chunks = 2